<template>
  <v-dialog v-model="showModal" width="30vw" @click:outside="showModal = false">
    <v-card height="30vh">
      <v-col cols="12" class="fill-height">
        <v-card elevation="0">
          <div class="d-flex justify-end">
            <v-btn text @click="showModal = false" class="dialog-close-btn">
              <v-icon>mdi-close </v-icon>
            </v-btn>
          </div>
          <div class="d-flex flex-column justify-center align-center fill-height">
            <div class="font-weight-bold black--text my-8">
              {{ $t('Analytics.enjoyingOpinew') }}
            </div>
            <div class="font-weight-regular black--text mb-8">
              {{ $t('Analytics.rateYourExperience') }}
            </div>
            <div class="text-center d-block">
              <v-rating
                v-model="rating"
                background-color="yellow"
                hover
                color="yellow"
                x-large
                @input="openWindow(rating)"
              />
            </div>
          </div>
        </v-card>
      </v-col>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  name: 'OpinewAppStoreReviewRequestModal',
  data() {
    return {
      rating: 0,
      showModal: false,
    };
  },
  methods: {
    ...mapActions(['hideRequestAppStoreReviewModal']),
    openWindow(rating) {
      let link = 'https://apps.shopify.com/photo-reviews/reviews#modal-show=ReviewListingModal';
      if (this.daysSinceShopCreation < 45) {
        // shops created within 45 days or less can't leave reviews on shopify app store
        // we send them to capterra instead
        link = 'https://reviews.capterra.com/new/181008?lang=en';
      }
      if (rating >= 4) {
        window.open(link, '_blank');
        this.showModal = false;
      } else {
        window.open(
          'https://puo9qqvmhi8.typeform.com/to/vXiK7LOj#' +
            'shopid=' +
            this.accountInfo.shopId +
            '&firstname=' +
            this.accountInfo.shopOwnerName +
            '&email=' +
            this.accountInfo.shopOwnerEmail +
            '&shopify_domain=' +
            this.accountInfo.shopDomain +
            '&shopify_plan=' +
            this.accountInfo.shopifyPlanName +
            '&opinew_plan=' +
            this.accountInfo.planName +
            '&opinew_price=' +
            this.accountInfo.planPrice,
          '_blank'
        );
        this.showModal = false;
      }
    },
    considerShowingModal() {
      if (
        this.daysSinceOpinewInstallation >= 8 &&
        !this.accountInfo.shopLeftAppstoreReview &&
        this.accountInfo.uiShowRequestShopifyReviewModal
      ) {
        this.showModal = true;
        this.hideRequestAppStoreReviewModal();
      } else {
        this.showModal = false;
      }
    },
  },
  computed: {
    ...mapState(['accountInfo']),
    ...mapGetters(['daysSinceOpinewInstallation', 'daysSinceShopCreation']),
  },
  mounted() {
    this.considerShowingModal();
  },
};
</script>

<style scoped>
.dialog-close-btn {
  position: relative;
}

.dialog-close-btn::before {
  background: transparent !important;
}
.dialog-close-btn:hover::after {
  content: '';
  position: absolute;
  inset: 2px;
  border-radius: 25%;
  background-color: rgba(138, 138, 138, 0.2);
}
.dialog-close-btn {
  height: 30px !important;
  min-width: 30px !important;
  padding: 0 !important;
}
.dialog-close-btn i {
  font-size: 14px;
}
</style>
